import { Component, OnInit } from '@angular/core';
import { GlobalMessageService, TranslationService } from '@spartacus/core';
import { OrderConfirmationThankYouMessageComponent } from '@spartacus/order/components';
import { Order, OrderFacade } from '@spartacus/order/root';
import { Observable } from 'rxjs';

@Component({
  selector: 'atg-order-confirmation-thankyou-msg',
  templateUrl: './atg-order-confirmation-thankyou-msg.component.html',
  styleUrl: './atg-order-confirmation-thankyou-msg.component.scss',
  standalone: false
})
export class AtgOrderConfirmationThankyouMsgComponent extends OrderConfirmationThankYouMessageComponent implements OnInit{
  order$: Observable<Order>;
  constructor(
    protected orderFacade: OrderFacade,
    protected globalMessageService: GlobalMessageService,
    protected translationService: TranslationService
  ) {
    super(orderFacade, globalMessageService, translationService);
  }
   ngOnInit(): void {
    super.ngOnInit();
  }
}

